import { FluidLink } from "../../common/components/FluidLink";
import { getPathWithSearchParams } from "../../router-path";
import {
	ChangeRequestResourceType,
	ChangeRequestType,
} from "../../requests_cm/gepoChangeRequestService/types";
import { TabID } from "../contract_period/ContractPeriodTabs";

export const ChangeRequestResourceName = ({
	changeRequest,
}: {
	changeRequest?: ChangeRequestType;
}) => {
	if (
		changeRequest?.resource_type ===
			ChangeRequestResourceType.CONTRACT_PERIOD &&
		changeRequest?.resource_edit_path
	) {
		return (
			<FluidLink
				href={getPathWithSearchParams(
					changeRequest.resource_edit_path,
					{
						tab: TabID.DEAL,
					}
				)}
			>
				{changeRequest.name}
			</FluidLink>
		);
	}

	return <>{changeRequest?.name}</>;
};
